/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcProxyvoteV1ProxyTaskState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PROXYVOTE_V1_PROXY_TASK_STATE_ENTITY_NAME = 'ixc.proxyvote.v1.ProxyTask';
export const ixcProxyvoteV1ProxyTaskStateEntity = new schema.Entity<IxcProxyvoteV1ProxyTaskState>(IXC_PROXYVOTE_V1_PROXY_TASK_STATE_ENTITY_NAME, {}, { idAttribute: 'taskId' });

